import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./Compoments/Header";
import Footer from "./Compoments/Footer";
import Home from "./pages/Home";
import LifetimeAccess from "./pages/Lifetime-Access";
import "./utils/scss/style.scss";
import "bootstrap/dist/css/bootstrap.css";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lifetime-access" element={<LifetimeAccess />} />
      </Routes>
      <Footer />
    </div>
  );
}
export default App;